import { Pipe, PipeTransform } from '@angular/core';
import { TipoInstituicaoEnsinoEnum } from '../components/api/models/tipoInstituicaoEnsinoEnum';

@Pipe({
  name: 'tipoInstituicao'
})

export class TipoInstituicaoEnumPipe implements PipeTransform {

  transform(value: TipoInstituicaoEnsinoEnum | string | undefined): string {
    if (value === undefined || value === null) {
      return 'Desconhecido';
    }
    return TipoInstituicaoEnsinoEnumDescriptions[value as TipoInstituicaoEnsinoEnum] || 'Desconhecido';
  }

}

export const TipoInstituicaoEnsinoEnumDescriptions: { [key in TipoInstituicaoEnsinoEnum]: string } = {
  0: "INTERNA",
  1: "EXTERNA",
};
